var msg = new Array();
msg['ERR_PRIVACY']='Трябва да приемете декларацията за поверителност.';
msg['ERR_MISSINGFIELDS']='Попълнете всички задължителни полета.';
msg['ERR_FILLEMAILFIELD']='Попълнете полето за имейл.';
msg['ERR_USEREXISTS']='Потребителят съществува.';
msg['ERR_INVALIDMAIL']='Невалиден имейл адрес.';
msg['ERR_CLIENTMANDATORYFIELDS']='Попълнете всички задължителни полета';
msg['ERR_NOSIZESELECTED']='Трябва да изберете размер';
msg['ERR_LOGINREQUIRED']='Изисква се вход';
msg['ERR_LOGININVALID']='Невалиден имейл или парола';
msg['ERR_CARRIERMISSING']='Първо трябва да изберете тип изпращане.';
msg['ERR_CARRIER_COST_MISSING']='Без такса за избран превозвач в страната и тегло на поръчката.';
msg['MSG_DEFERRED_DISPATCH_COMPUTATION']='Ще бъде активиран само режимът за резервиране на поръчки и таксите за изпращане ще ви бъдат изпратени по имейл.';
msg['MSG_ADDEDTOWISHLIST']='Продуктът е добавен в списъка ви с желания';
msg['MSG_NEWSLETTER_COMPLETED']='Успешна регистрация';
msg['MSG_ADDEDTOCART']='Продукти, добавени във вашата количка';
msg['MSG_REMOVEDFROMCART']='Продуктът е премахнат от количката';
msg['MSG_DELETEALLPRODUCTS']='Сигурни ли сте, че искате да премахнете всички продукти от количката?';
msg['DELETEALLPRODUCTSERROR']='Грешка при премахване на продукти от количката';
msg['MSG_WAIT']='Изчакайте, моля...';
msg['MSG_SUBJECT_PRODUCTSHARE']=' сподели нещо с вас';
msg['MSG_SENDER_PRODUCTSHARE']='Вашето име';
msg['MSG_MESSAGE_PRODUCTSHARE']='Съобщение';
msg['MSG_MAILSENT']='Изпратени електронни съобщения';
msg['MSG_MIXED_INTANGIBLE']='Този продукт не може да бъде закупен заедно с продукти, които вече имате в количката си за пазаруване.';
msg['MSG_MIXED_CART']='Този продукт не може да бъде закупен заедно с продукти, които вече имате в количката си за пазаруване, тъй като те се намират в различни складове.';
msg['MSG_INSUFFICIENT_STOCK']='Съжаляваме, но в момента не разполагаме с достатъчно налични продукти.';
msg['MSG_APPLIEDVATCHANGED']='След обновяване на данните за фактуриране ДДС, прилаган към вашата поръчка, се променя. Проверете новата сума, след като страницата се презареди.';
msg['MSG_GENERIC_ERROR']='Съжаляваме, възникна грешка.';
msg['MSG_COUPON_ERROR']='Въведеният код на купона не е валиден или вече е изгорял.';
msg['MSG_COUPON_VALID']='Въведеният код на купона е приет успешно.';
msg['MSG_RECOVEREMAILSENT']='Проверете имейла си и въведете кода, за да потвърдите смяната на паролата.';
msg['MSG_RECOVEREMAILSENT_ERROR']='Предупреждение: не сте регистрирани с този имейл адрес или вече сте възстановили паролата си.';
msg['MSG_SUBSCRIPTION_FAILURE']='Уверете се, че нямате друг активен абонамент.';
msg['MSG_EXTRAUELIMIT']='Не можете да чекирате поръчки с данъчна основа, по-малка от 2000,00 евро;';
msg['MSG_RULE_REJECT']='Продуктът не може да бъде добавен в количката поради правило :rule';
msg['LABEL_ARTICLES']='статии';
msg['LABEL_WARNING']='Предупреждение';
msg['LABEL_NOTAPPLICABLE']='Не е приложимо';
msg['LABEL_ALREADYREGISTEREDUSERES']='Вече регистрирани потребители';
msg['LABEL_SENTINVITES']='Изпратени покани';
msg['LABEL_NOTSENTINVITES']='Неизпратени покани';
msg['LABEL_INVITES_ALREADY_SENT']='Вече поканени потребители';
msg['LABEL_SUBMIT']='Подаване на';
msg['LABEL_SELECTALL']='Изберете всички';
msg['MSG_MESSAGE_SENT']='Съобщението е изпратено успешно!';
msg['MSG_RETURN_REQUEST_SUCCESS'] = 'Заявката за връщане е създадена успешно';
msg['MSG_SAVE_SUCCESS'] = 'Запазване на успешен';
msg['MSG_SUBSCRIBED'] = 'Успешно регистриран';
msg['MSG_PROFILECONSENT_SAVED'] = 'Вашите предпочитания за контакт са актуализирани';
msg['wrongpassword'] = 'Грешна парола';
msg['passwordnotcomplex'] = 'Паролата не е достатъчно сложна';
msg['MSG_PASSWORD_OK'] = 'Паролата е променена правилно';
msg['MSG_PASSWORD_NOT_EQUAL'] = 'паролите не съвпадат';
msg['MSG_PRIVACY_POLICY'] = 'Трябва да приемете правилата за поверителностy';
msg['MSG_SUBSCRIPTION_NO_RENEWABLE'] = 'Изминали са твърде много дни, така че абонаментът вече не може да се подновява';
msg['MSG_GIFTCARD_SUCCESS'] = 'Вашата карта за подарък беше приета';
msg['INVALID_GIFTCARD'] = 'Невалидна карта за подарък';
msg['ERR_REWIXSYNC_URL']= 'Невалиден URL адрес';
msg['msg.form.invalidtype'] = 'Възникна грешка. Свържете се с администрацията, като съобщите следното: "Невалиден или отсъстващ тип контакт."';
msg['login.user.unexisting'] = "Потребител не съществува";
msg['msg.form.invalidemail'] = 'Невалиден или липсващ имейл';
msg['msg.form.invalidrecipients'] = 'Възникнала е грешка. Свържете се с администрацията, като съобщите следното: "Невалидни или липсващи получатели на контакти."';

var portal_livestock_available='ДОСТЪПЕН';
var portal_livestock_soldout='ПРОДАДЕНО';

var activity_online_shop = 'онлайн магазин';
var activity_shop = 'магазин';
var activity_private_sales = 'частни продажби';
var activity_outlet = 'Изход';
var activity_online_outlet = 'онлайн магазин';
var activity_store_chain = 'верига магазини';
var activity_purchasing_group = 'група за покупки';
var activity_broker = 'брокер/агент';
var activity_ebay_amazon = 'Магазин на ebay/amazon';
var activity_other = 'други';

var general='Общ';
var general_personaldata='Лични данни';
var general_olduser='Регистриран потребител';
var general_newuser='Нов потребител';
var general_username="Потребителско име";
var general_password="Password";
var general_contacts='Контакти';
var general_phone='Номер на телефона';
var general_skype='Skype';
var general_website='Уебсайт';
var general_fax='Факс';
var general_firstname='Първо име';
var general_lastname='Фамилия';
var general_company='Компания';
var general_birth='Дата на раждане';
var general_code='Код';
var general_model='Модел';
var general_quantity='Количество';
var general_availability='Наличност';
var general_price='Цена';
var general_warning='Предупреждение';
var general_dispatchto='Име на компанията/адресата';
var general_careof='C/O';
var general_vat='VAT';
var general_address='Адрес';
var general_addresstype='Вид на адреса';
var general_addressnumber='Номер';
var general_city='Град';
var general_prov='Prov';
var general_zip='пощенски код';
var general_mobile='Мобилен';
var general_notes='Бележки';
var general_orders='Поръчки';
var general_fgfdiscounts='Приятели и отстъпки';
var general_myprofile='Моят профил';
var general_pieces='pc';
var general_size_table='Таблица с размери';
var general_details='Подробности';
var general_invoice='Фактура';
var general_creditnote='Кредитна бележка';
var general_cart= 'Количка за пазаруване';
var general_country='Държава';
var general_carrier='Преносител';
var general_dispatch_address='Диспечерски адрес';
var general_invoice_address='Адрес на фактурата';
var general_receive_newsletter='Получаване на бюлетин';
var general_copydispatchfrombilldata='Копиране от данните за фактуриране';
var general_instructions="Инструкции";
var general_add="Добавяне на";
var general_status="Статус";
var general_toomanyfilters="Достигнат е максималният брой разрешени филтри.";

var help_addresstype='Улица, площад, игрище, ...';
var help_address='Име на улицата';
var help_dispatchmobile='Този номер ще бъде използван от превозвача.';
var help_ordercfpiva='Празната стойност автоматично ще добави 20% ДДС към стойността на поръчката..';
var help_cf='Въведете своя SSN';

var buttons_save='Запазете';
var buttons_changepw='Промяна на паролата';
var buttons_close='Затвори';
var buttons_continue='Продължи';
var buttons_confirm='Потвърдете';
var buttons_cancel='Отмяна на';
var buttons_invite='Invita';
var buttons_continueshopping='Продължете с пазаруването';
var buttons_gocheckout='Отидете на касата';

var messages_product_soldout='Продуктът е продаден.';
var messages_noselection='Няма избор';
var messages_invaliddata='Невалидни данни.';
var messages_recoverpassword='Възстановяване на парола';
var messages_recoverpassword_info='Въведете имейла, с който сте се абонирали<br/>Ще получите имейл с инструкциите, за да получите възстановяване на паролата си';
var messages_invitefriends='Поканете приятелите си';
var messages_confirmpassword='Потвърждаване на паролата';
var messages_sendingmail='Изпращане на поща...';
var messages_mailsent='Изпратена електронна поща.';
var messages_password='Парола';
var messages_confirmpassword='Потвърждаване на паролата';
var messages_requiredfield='Задължително поле';

var subscribe_personaldata='Лични данни';
var subscribe_privacyintro='За да продължите с абонамента, трябва да приемете следното условие.';
var subscribe_privacydisclaimer = 'За да продължите с абонамента, трябва да приемете декларацията за поверителност.';
var subscribe_privacy1='Приемам отказа от отговорност за поверителност';
var subscribe_privacy2='Приемам личните ми данни да бъдат използвани от други фирми за маркетингови кампании (по избор)';

var order_status='Статус'
var order_date='Дата'
var order_dispatchdate='Изпратени';

var returnedgoods_requests="Заявка за върнати стоки";
var returnedgoods_motivations="Мотивация на върнатите стоки";
var returnedgoods_requestcode="Код на заявката за върнати стоки";
var returnedgoods_requestdate="Дата на заявката";
var returnedgoods_motivations_1="Не ми харесва продуктът";
var returnedgoods_motivations_2="Продуктът е твърде голям/малък";
var returnedgoods_motivations_3="Продуктът е повреден";
var returnedgoods_motivations_4="Продуктът не съответства на поръчаната стока";
var returnedgoods_motivations_5="Продуктът не е в опаковката";
var returnedgoods_motivations_other = "Други";

var i18nOrderStatus = new Array();
i18nOrderStatus[0]='Висулка';
i18nOrderStatus[1]='При плащане';
i18nOrderStatus[2]='Потвърдено';
i18nOrderStatus[3]='Изпратени';
i18nOrderStatus[4]='Доставен';
i18nOrderStatus[5]='Резервирано';
i18nOrderStatus[6]='Dropshipping';
i18nOrderStatus[2000]='Отменен';
i18nOrderStatus[2001]='Грешка';
i18nOrderStatus[3001]='В процес на изпълнение';
i18nOrderStatus[3002]='Готов';

i18nOrderStatus[1000]='Отменено плащане';
i18nOrderStatus[2002]='Проверката на плащането е неуспешна';
i18nOrderStatus[2003]='Възстановени средства';
i18nOrderStatus[2005]='Отхвърлени';
i18nOrderStatus[3003]='Не подлежи на изпращане';
i18nOrderStatus[5001]='Не е разрешено';
i18nOrderStatus[5002]='Оторизиран';
i18nOrderStatus[5003]='дропшипинг - Растеж';